var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemibox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 5.79086 5.79086 4 8 4H26V68H8C5.79086 68 4 66.2091 4 64V8Z",
    className: "svg-slate-200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 4,
    width: 77,
    height: 8,
    rx: 1,
    className: "svg-slate-200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 25,
    height: 17,
    rx: 1,
    className: "svg-slate-200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 16,
    width: 48,
    height: 17,
    rx: 1,
    className: "svg-slate-200"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    width: 77,
    height: 23,
    rx: 1,
    className: "svg-slate-200"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 64,
    width: 77,
    height: 4,
    rx: 1,
    className: "svg-slate-200"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 10,
    height: 9,
    rx: 2,
    className: "svg-slate-300"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 18,
    height: 4,
    rx: 1,
    className: "svg-slate-300"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 18,
    height: 4,
    rx: 1,
    className: "svg-slate-300"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 44,
    width: 18,
    height: 4,
    rx: 1,
    className: "svg-slate-300"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 52,
    width: 18,
    height: 4,
    rx: 1,
    className: "svg-slate-300"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 2,
    className: "svg-slate-300"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 8,
    r: 2,
    className: "svg-slate-300"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 8,
    r: 2,
    className: "svg-slate-300"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 8,
    r: 2,
    className: "svg-slate-300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemibox);
export default __webpack_public_path__ + "static/media/semibox.52299780edc7eae9c33991a9c2fb7d49.svg";
export { ForwardRef as ReactComponent };